document.documentElement.classList.remove('no-js');
const menuButton=document.querySelector('.mobile-menu-button');
const mobileMenu=document.querySelector('#MobileMenu');
if(menuButton&&mobileMenu){menuButton.addEventListener('click',()=>{const open=menuButton.getAttribute('aria-expanded')==='true';menuButton.setAttribute('aria-expanded',String(!open));mobileMenu.hidden=open;mobileMenu.classList.toggle('open',!open)})}
document.querySelectorAll('[data-sound-toggle]').forEach((button) => {
  const videoArea = button.closest('.hero__media');
  const video = videoArea?.querySelector('video');

  if (!video) return;

  button.addEventListener('click', async () => {
    if (video.muted) {
      video.muted = false;
      video.currentTime = 0;

      try {
        await video.play();
        button.textContent = button.dataset.muteLabel;
        button.setAttribute('aria-pressed', 'true');
        button.setAttribute('aria-label', button.dataset.muteLabel);
      } catch (error) {
        video.muted = true;
      }
    } else {
      video.muted = true;
      button.textContent = button.dataset.soundLabel;
      button.setAttribute('aria-pressed', 'false');
      button.setAttribute('aria-label', button.dataset.soundLabel);
    }
  });
});
document.querySelectorAll('[data-product-section] select[name="id"]').forEach((select)=>{select.addEventListener('change',()=>{const url=new URL(window.location.href);url.searchParams.set('variant',select.value);window.location.assign(url.toString());});});
